import React, { useEffect } from 'react';
import Login from './components/auth/Login';
import { ConfigProvider } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoadingFullscreen from "./components/LoadingFullscreen";
import Entry from './components/screens/Entry';
import Screen from './components/screens/Screen';
import Producer from "./components/screens/Producer";
import Omni from './components/screens/Omni';
import SetupInterceptors from "./components/SetupInterceptors";
import {EpisodeProvider} from "./contexts/EpisodeContext";

function App() {
  return (
      <ConfigProvider theme={{ token: { colorPrimary: '#FEC301', colorTextLightSolid: 'red', colorLink: '#D60411', colorTextBase: '#fff', colorBgBase: '#222' }, components: { Button: { fontWeight: 'bold' } } }}>
        <Router>
            <AuthProvider>
                <EpisodeProvider>
                    <SetupInterceptors />
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/loading" element={<LoadingFullscreen />} />
                        <Route path="/entry" element={<Entry />} />
                        <Route path="/screen" element={<Screen />} />
                        <Route path="/producer" element={<Producer />} />
                        <Route path="/omni" element={<Omni />} />
                    </Routes>
                </EpisodeProvider>
            </AuthProvider>
        </Router>
      </ConfigProvider>
  );
}

export default App;
